/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router";
import { Container } from "@mui/material";

import { getBreadcrumbDeviceRoute } from "@/utils/getBreadcrumbRoute";

import Breadcrumb from "@/components/UI-Kit/Breadcrumb";
import {
  Details,
  Comparison,
  MainCharacteristics,
  OtherProducts,
  ProductCardNew,
} from "@/components/ProductDetails";
import { fetchProductById } from "@/api/fetchProductById";
import { Box } from "@mui/system";

const ProductDetails = () => {
  const { deviceId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const detailsRef = useRef<any>(null); // Ref for the Details section

  const [product, setProduct] = useState<IProductDetails | null>(null); // Current product

  // Get current product based on device/product ID
  useEffect(() => {
    const getProductData = async (id: number) => {
      const product = await fetchProductById(id);

      // If no product by Id found - navigate to Not Found page
      if (!product) {
        navigate(`NotFound`);
      } else {
        setProduct(product);
      }
    };

    // If no device Id - navigate to Not Found page
    if (!deviceId) {
      navigate(`NotFound`);
    } else {
      getProductData(+deviceId);
    }
  }, [deviceId, navigate]);

  // Scroll to details section on "Read more" button click
  const scrollToDetails = () => {
    if (detailsRef.current) {
      detailsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 3, lg: 0 } }}>
        <Breadcrumb
          options={getBreadcrumbDeviceRoute(location, product?.name || "")}
        />
      </Container>

      {product && (
        <Box
          display={{ xs: "block", md: "flex", lg: "flex" }}
          flexWrap="wrap"
          flexDirection={{ xs: "column", md: "row", lg: "row" }}
          justifyContent={"center"}
        >
          <ProductCardNew product={product} scrollToDetails={scrollToDetails} />
          <MainCharacteristics
            title={product.name}
            properties={product.properties}
          />
          <Details product={product} ref={detailsRef} />
          <Comparison />
          <OtherProducts />
        </Box>
      )}
    </>
  );
};

export default ProductDetails;
